import * as React from "react";
import { UserGroup } from "gen/clients";
import { useUserSession } from "./useUserSession";

export const useIsSuperUser = (): boolean => {
  const { roles } = useUserSession();
  return React.useMemo(() => roles?.includes(UserGroup.SUPER_USER) || false, [roles]);
};
